import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { IStockMoveActionData } from '@kinet-open-network/shared/data-access/model';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { of } from 'rxjs';
import { StockMovesService } from '../services/stock-moves.service';

export const StockMovesStore = signalStore(
  { protectedState: false },
  withResourceState(StockMovesService, {
    query: {
      initial: {
        sort: ['-moveDate'],
      },
    },
  }),
  withMethods((store, service = inject(StockMovesService)) => ({
    loadItems: () => {
      patchState(store, setLoading());
      return callApiMethod(() => of({ items: [{}, {}] }), {
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, setLoaded()),
      });
    },
    exportItems: async (id: string) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.exportMoveItems(id), {
        next: () => patchState(store, setLoaded()),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, setLoaded()),
      });
    },
    exportToAccounting: async (id: string) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.exportToAccounting(id), {
        next: (move) => patchState(store, { model: move }, setLoaded()),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, setLoaded()),
      });
    },
    batchAction: (data: IStockMoveActionData) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.batchAction(data, store.query()), {
        next: () => patchState(store, setLoaded()),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, setLoaded()),
      });
    },
  })),
);
